"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["CHF"] = "CHF";
})(Currency = exports.Currency || (exports.Currency = {}));
//# sourceMappingURL=Currency.js.map